import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Construction from 'src/store/models/Construction';
import City from 'src/store/models/City';
import State from 'src/store/models/State';
import Company from 'src/store/models/Company';
import Loading from 'quasar/src/plugins/Loading.js';import QPagination from 'quasar/src/components/pagination/QPagination.js';;
import { groupBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'SearchResults',
  meta: {
    // sets document title
    title: 'Trovacantieri',
    // meta tags
    meta: {
      description: {
        name: 'description',
        content: 'Case in vendita di nuova costruzione proposte direttamente dalle imprese'
      },
      keywords: {
        name: 'keywords',
        content: 'trovacantieri cantieri vendita case immobili'
      },
      equiv: {
        'http-equiv': 'Content-Type',
        content: 'text/html; charset=UTF-8'
      }
    }
  },
  components: {
    QPagination: QPagination
  },
  data: function data() {
    return {
      loading: false,
      filters: {
        type: null,
        contract: 'sale',
        from_price: 0,
        to_price: null,
        from_area: 0,
        to_area: null,
        attic: false,
        detached: false,
        has_garden: false,
        bathrooms: null,
        rooms: null,
        bounds: null,
        delivery: null,
        company_id: null
      },
      citySlug: null,
      stateSlug: null,
      companySlug: null
    };
  },
  watch: {
    '$route.query': function $routeQuery(val, oldval) {
      if (val.page !== oldval.page) {
        this.refetchConstructions(val.page);
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentPage: 'entities/constructions/current_page',
    lastPage: 'entities/constructions/last_page',
    perPage: 'entities/constructions/per_page',
    total: 'entities/constructions/total'
  })), {}, {
    constructions: function constructions() {
      return Construction.query().withAllRecursive().orderBy('distance').get();
    },
    city: function city() {
      return City.query().where('slug', this.citySlug).first();
    },
    state: function state() {
      return State.query().where('slug', this.stateSlug).first();
    },
    company: function company() {
      return Company.query().where('slug', this.companySlug).first();
    },
    cityGroups: function cityGroups() {
      return Object.values(groupBy(this.constructions, 'city_id')).map(function (group) {
        return {
          city: group[0].city,
          constructions: group
        };
      });
    },
    stringFilters: function stringFilters() {
      return Buffer.from(JSON.stringify(this.filters)).toString('base64');
    }
  }),
  methods: {
    refetchConstructions: function refetchConstructions() {
      var _this = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.$q.loading.show();
      if (this.boundsChanged) {
        this.filters.city_id = null;
        this.filters.state_id = null;
        this.$store.dispatch('entities/constructions/resetPaginator');
      }
      Construction.api().get('api/constructions', {
        dataKey: 'data',
        params: _objectSpread(_objectSpread({}, this.filters), {}, {
          page: page,
          per_page: 20
        })
      }).then(function (result) {
        Construction.delete(function (value) {
          var constructionIds = result.response.data.data.map(function (construction) {
            return construction.id;
          });
          return constructionIds.indexOf(value.id) === -1;
        });
        var meta = {
          current_page: result.response.data.current_page,
          last_page: result.response.data.last_page,
          per_page: result.response.data.per_page,
          total: result.response.data.total
        };
        _this.$store.dispatch('entities/constructions/setPagination', meta);
        _this.$q.loading.hide();
      }).catch(function () {
        _this.$q.loading.hide();
      });
    },
    filterCities: function filterCities(val, update, abort) {
      var _this2 = this;
      City.api().get('api/cities', {
        dataKey: 'data',
        params: {
          name: val
        }
      }).then(function (cities) {
        update(function () {
          if (val === '') {
            _this2.cities = [];
          } else {
            _this2.cities = cities;
          }
        });
      }).catch(function () {
        abort();
      });
    },
    fetchData: function fetchData(resolve) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this3.stateSlug) {
                _context.next = 7;
                break;
              }
              if (_this3.state) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return State.$getBySlug(_this3.stateSlug).then(function (response) {
                _this3.filters.state_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 4:
              _context.next = 7;
              break;
            case 6:
              _this3.filters.state_id = _this3.state.id;
            case 7:
              if (!_this3.citySlug) {
                _context.next = 14;
                break;
              }
              if (_this3.city) {
                _context.next = 13;
                break;
              }
              _context.next = 11;
              return City.$getBySlug(_this3.citySlug).then(function (response) {
                _this3.filters.city_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 11:
              _context.next = 14;
              break;
            case 13:
              _this3.filters.city_id = _this3.city.id;
            case 14:
              if (!_this3.companySlug) {
                _context.next = 21;
                break;
              }
              if (_this3.company) {
                _context.next = 20;
                break;
              }
              _context.next = 18;
              return Company.$getBySlug(_this3.companySlug).then(function (response) {
                _this3.filters.company_id = response.data.id;
              }).catch(function (e) {
                console.error(e);
              });
            case 18:
              _context.next = 21;
              break;
            case 20:
              _this3.filters.company_id = _this3.company.id;
            case 21:
              return _context.abrupt("return", Construction.api().get('api/constructions', {
                dataKey: 'data',
                params: _objectSpread(_objectSpread({}, _this3.filters), {}, {
                  per_page: 20
                })
              }).then(function (result) {
                var meta = {
                  current_page: result.response.data.current_page,
                  last_page: result.response.data.last_page,
                  per_page: result.response.data.per_page,
                  total: result.response.data.total
                };
                _this3.$store.dispatch('entities/constructions/setPagination', meta);
              }));
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  serverPrefetch: function serverPrefetch(_ref) {
    var store = _ref.store,
      currentRoute = _ref.currentRoute,
      previousRoute = _ref.previousRoute,
      redirect = _ref.redirect,
      ssrContext = _ref.ssrContext,
      urlPath = _ref.urlPath,
      publicPath = _ref.publicPath;
    Loading.show();
    Construction.deleteAll();
    this.stateSlug = this.$router.currentRoute.params.stateSlug;
    this.citySlug = this.$router.currentRoute.params.citySlug;
    this.companySlug = this.$router.currentRoute.params.companySlug;
    if (this.$router.currentRoute.query.filters) {
      try {
        this.filters = JSON.parse(Buffer.from(this.$router.currentRoute.query.filters, 'base64').toString());
      } catch (e) {
        console.log(e);
      }
    }
    return this.fetchData();
  },
  mounted: function mounted() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this4.stateSlug = _this4.$router.currentRoute.params.stateSlug;
            _this4.citySlug = _this4.$router.currentRoute.params.citySlug;
            _this4.companySlug = _this4.$router.currentRoute.params.companySlug;
            if (_this4.city) {
              _this4.filters.city_id = _this4.city.id;
            }
            if (_this4.state) {
              _this4.filters.state_id = _this4.state.id;
            }
            if (_this4.$router.currentRoute.query.filters) {
              try {
                _this4.filters = JSON.parse(Buffer.from(_this4.$router.currentRoute.query.filters, 'base64').toString());
              } catch (e) {
                console.log(e);
              }
            }
            if (!(_this4.constructions.length === 0 || _this4.stateSlug && !_this4.state || _this4.citySlug && !_this4.city)) {
              _context2.next = 9;
              break;
            }
            _context2.next = 9;
            return _this4.fetchData();
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};